import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import { ASSET_TYPES } from 'personalization-lib/constants/assetTypes';

// ASSET URLS
const getFromPersonalizationParam = strategyId => strategyId ? `?fromPersonalizationStrategyId=${strategyId}` : '';
const getAssetEditorBaseUrl = ({
  source,
  id
}) => {
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/edit/${id}`;
    case ASSET_TYPES.LANDING_PAGE:
      return `/pages/${PortalIdParser.get()}/editor/${id}`;
    default:
      return '';
  }
};
export const getAssetEditorUrl = ({
  source,
  id
}, strategyId) => {
  const search = getFromPersonalizationParam(strategyId);
  const baseUrl = getAssetEditorBaseUrl({
    source,
    id
  });
  return baseUrl && `${baseUrl}/content${search}`;
};
export const getAssetPreviewUrl = ({
  source,
  id
}, strategyId) => {
  const search = getFromPersonalizationParam(strategyId);
  const baseUrl = getAssetEditorBaseUrl({
    source,
    id
  });
  return baseUrl && `${baseUrl}/preview${search}`;
};
export const getAssetDetailsUrl = ({
  source,
  id
}, strategyId) => {
  const search = getFromPersonalizationParam(strategyId);
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/details/${id}/performance${search}`;
    case ASSET_TYPES.LANDING_PAGE:
      return `/page-details/${PortalIdParser.get()}/landing-page/${id}/performance${search}`;
    default:
      return '';
  }
};
export const getAssetCreateUrl = assetType => {
  switch (assetType) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/create`;
    case ASSET_TYPES.LANDING_PAGE:
      {
        const queryParams = {
          referrer: 'personalization',
          referrerUrl: window.location.href
        };
        return `/page-creation/${PortalIdParser.get()}/create-page/landing-page/template?${stringify(queryParams)}`;
      }
    default:
      return '';
  }
};